/**
 * Dependencies.
 */
import { throttle } from 'lodash-es';
import { PluginFunction, PluginObject, VueConstructor } from 'vue';

import { ILayout } from '@/modules/main/types';

/**
 * Plugin install function.
 */
const install: PluginFunction<any> = (Vue: VueConstructor) => {
  /**
   * Now state.
   */
  const nowState = new Vue({
    created() {
      this.fn = throttle(this.handleWindowResize, 100);

      this.$nextTick(() => {
        window.addEventListener('resize', this.fn);

        this.handleWindowResize();
      });
    },
    data: {
      fn: null,
      layout: {
        height: {
          sm: false,
          smAndDown: false,
          smAndUp: false,
          xsm: false,
          xsmAndUp: false,
          xsmLarger: false,
          xsmLargerAndDown: false,
          xsmLargerAndUp: false
        }
      },
      loading: false
    },
    methods: {
      handleWindowResize() {
        const hg = document.documentElement.clientHeight;

        const smLimit = 568;
        const xsmLimit = 320;
        const xsmLargerLimit = 375;

        const layout = {
          height: {
            sm: hg > xsmLargerLimit && hg <= smLimit,
            smAndDown: hg <= smLimit,
            smAndUp: hg > smLimit,
            xsm: hg <= xsmLimit,
            xsmAndUp: hg > xsmLimit,
            xsmLarger: hg > xsmLimit && hg <= xsmLargerLimit,
            xsmLargerAndDown: hg <= xsmLargerLimit,
            xsmLargerAndUp: hg > xsmLargerLimit
          }
        };

        this.$nextTick(() => {
          this.$now.layout = layout;
        });
      }
    }
  });

  /**
   * Define property `$now`.
   */
  if (!Vue.prototype.$now) {
    // eslint-disable-next-line id-match
    Vue.prototype.$now = {};
  }

  /**
   * Define property `isLoading`.
   */
  Object.defineProperty(Vue.prototype, 'isLoading', {
    get() {
      return nowState.loading;
    },
    set(loading: boolean) {
      nowState.loading = loading;
    }
  });

  /**
   * Define property `layout`.
   */
  Object.defineProperty(Vue.prototype.$now, 'layout', {
    get() {
      return nowState.layout;
    },
    set(layout: ILayout) {
      nowState.layout = {
        ...nowState.layout,
        ...layout
      };
    }
  });
};

/**
 * Define `plugin`.
 */
const plugin: PluginObject<{}> = {
  install
};

/**
 * Export default `plugin`.
 */
export default plugin;
